function state() {
  return {
    personalLines: [],
    personalLinesMeta: {},
    quickViews: [],
    personalLine: {},
    listProductCategory: [],
    listInsuranceBranch: [],
  };
}

export default state;
